import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthFacade } from '../../features/auth/facade/auth.facade';

export const authGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  if (!authFacade.isAuthenticated()) {
    router.navigate(['/auth/login']);
    return false;
  }

  return authFacade.checkSessionStatus().pipe(
    map((isActive) => {
      if (!isActive) {
        return false;
      }
      return true;
    }),
    catchError(() => of(true))
  );
};
